function isDataSeries(object) {
  if (object.data && object.data.length > 0) {
    const [dataPoint] = object.data;
    return Object.prototype.hasOwnProperty.call(dataPoint, 'value') && Object.prototype.hasOwnProperty.call(dataPoint, 'key');
  }
  return false;
}
function isDataSeriesArray(array) {
  if (array.length > 0) {
    const [series] = array;
    return isDataSeries(series);
  }
  return false;
}

export { isDataSeries, isDataSeriesArray };
